import { useEffect } from 'react';

// While `isOpen` is true, close the floating element as soon as any scroll or
// viewport resize happens. Scroll events do not bubble, so the listener is
// attached in the capture phase on `window`: this catches scrolling from any
// ancestor container, including virtualized table bodies, without coupling to a
// specific scroll node. The listeners exist only while the element is open, so
// idle tooltips add no global listeners and the table scroll handler stays
// untouched and lightweight.
export const useCloseFloatingOnScroll = (
  isOpen: boolean,
  onClose: () => void
): void => {
  useEffect(() => {
    if (!isOpen) return;

    const closeHandler = () => onClose();

    window.addEventListener('scroll', closeHandler, {
      capture: true,
      passive: true,
    });
    window.addEventListener('resize', closeHandler, { passive: true });

    return () => {
      window.removeEventListener('scroll', closeHandler, { capture: true });
      window.removeEventListener('resize', closeHandler);
    };
  }, [isOpen, onClose]);
};
